import React from 'react';

function Header({ toggleSidebar }) {
    return (
        <>
            {/* Mobile Menu Button */}
            <button
                id="menuToggle"
                className="lg:hidden fixed top-4 mt-3 left-4 z-50 w-10 h-10 bg-primary text-white rounded-lg flex items-center justify-center"
                onClick={toggleSidebar}
            >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"/>
                </svg>
            </button>

            {/* Header */}
            <header className="bg-primary rounded-xl text-white px-6 m-3 lg:px-8 py-4 flex items-center justify-between">
                <h1 className="text-base lg:text-xl font-semibold ml-12 lg:ml-0">READ 21: Fast Track to Reading</h1>
                <div className="flex items-center gap-3">
                    <button className="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-opacity-30 transition-colors">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                        </svg>
                    </button>
                    <div className="hidden sm:flex items-center gap-2 bg-white text-primary px-3 py-2 rounded-xl shadow-sm">
                        <div className="w-8 h-8 bg-gradient-to-br from-gray-600 to-gray-800 text-white rounded-full flex items-center justify-center font-semibold text-sm">NG</div>
                        <div className="text-left">
                            <div className="text-[10px] text-gray-600 leading-tight">Node</div>
                            <div className="text-xs font-semibold leading-tight">Nahom Girma</div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
}

export default Header;